import { Middleware, configureStore } from "@reduxjs/toolkit";
import reduxLogger from "redux-logger";
import rootReducer from "./rootReducer";
import { ENVIRONMENTS } from "shared/constant";
import { Config } from "../config";

const addLoggerMiddleware = (getDefaultMiddleware: typeof configureStore.prototype.middleware): Middleware[] => {
  if (Config.environment == ENVIRONMENTS.DEVELOPMENT) {
    return getDefaultMiddleware().concat(reduxLogger);
  }
  return getDefaultMiddleware();
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: addLoggerMiddleware
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
